// extracted by mini-css-extract-plugin
export var badge = "mini-cart-module--badge--2FlVu";
export var button = "mini-cart-module--button--dYtRB";